import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

// Platform admins can land on /affiliate or /affiliate/email with ?as=<id>
// from the "Preview as affiliate" action in /admin/affiliates. While the param
// is present, every affiliate API call forwards it so the backend resolver
// returns that affiliate's data instead of the caller's, and the UI shows a
// "you are previewing" banner with write actions disabled.
//
// apiParams MUST be memoized — callers pass it into useCallback/useEffect
// dep arrays. Returning a fresh object literal each render in preview mode
// turned every effect into an infinite re-render loop (each render produced
// a new apiParams → new load callback → effect re-fires → API call → toast
// on error → state update → another render → repeat).
export function useAffiliatePreview() {
  const [searchParams] = useSearchParams()
  const asParam = searchParams.get('as')
  const isPreview = !!asParam
  const apiParams = useMemo(
    () => (asParam ? { as: asParam } : undefined),
    [asParam],
  )
  const linkQuery = useMemo(
    () => (asParam ? `?as=${encodeURIComponent(asParam)}` : ''),
    [asParam],
  )
  return { asParam, isPreview, apiParams, linkQuery }
}
